export function getMeasureTypeOption(measurementOptionSelected, measurementOptions, customerMetafield, sendRefData) {
  const sendRefGarmentSelected = sendRefData.radio.selected;
  const sendRefGarmentSelectedOption = sendRefData.radio.options[sendRefGarmentSelected];

  const doesSendRefImpactVariantSelect = sendRefGarmentSelectedOption.doesImpactVariantSelect;
  const checkSendGarmentMeasureType = () => measurementOptionSelected === "send-fitting-garment" && doesSendRefImpactVariantSelect != undefined && doesSendRefImpactVariantSelect;
  
  if(measurementOptions?.[measurementOptionSelected]?.measureType)
    return measurementOptions?.[measurementOptionSelected]?.measureType;

  const hasDiscount = measurementOptions?.[measurementOptionSelected]?.hasDiscount;

  // if ((customerMetafield == null && hasDiscount) ) {
  //   return "custom";
  // }

  if (checkSendGarmentMeasureType()) {
    return sendRefGarmentSelectedOption.variant.measureType;
  }

  return "standard";
}

export function getCurrentFormCompletionStatus(FORM_COMPLETION_STATUS, diyMeasurements, measurementStatus) {
  const flags = Object.keys(measurementStatus).filter(measurementName => diyMeasurements[measurementName]['isEnabled']).map(measurementName => measurementStatus[measurementName]);

  const validFlags = flags.filter(flag => flag == MEAS_VALIDATION_STATUS.VALID);
  
  if(validFlags.length == 0) {
    return FORM_COMPLETION_STATUS.EMPTY;
  } else if(flags.length == validFlags.length) {
    return FORM_COMPLETION_STATUS.COMPLETE;
  } else {
    return FORM_COMPLETION_STATUS.HALF_COMPLETE
  }
}

export function getFirstInvalidMeasurementCursor(diyMeasurements, measurementStatus) {
  let index = -1;
  
  let totalActiveMeasurements = 1;
  let i = 1;
  for(const [measurementName, flag] of Object.entries(measurementStatus)) {
    if(!diyMeasurements[measurementName]['isEnabled']) continue;

    if([MEAS_VALIDATION_STATUS.EMPTY, MEAS_VALIDATION_STATUS.INVALID].includes(flag)) {
      index = i;
      break;
    }
    totalActiveMeasurements++;
    i++;
  }

  if(i === totalActiveMeasurements) return totalActiveMeasurements;

  return index;
}